import { BONUS_HUNT, JACKPOT_HUNT, STREAMERS_CHOICE, BONUS_BUY } from '../constants/we-spin-event-tags.js';

const getTranslation = (eventType, translations) => {
	switch (eventType) {
		case BONUS_HUNT:
			return translations.WE_SPIN_EVENT_TAG_BONUS_HUNT_BG_TEXT;
		case JACKPOT_HUNT:
			return translations.WE_SPIN_EVENT_TAG_JACKPOT_HUNT_BG_TEXT;
		case STREAMERS_CHOICE:
			return translations.WE_SPIN_EVENT_TAG_STREAMERS_CHOICE_BG_TEXT;
		case BONUS_BUY:
			return translations.WE_SPIN_EVENT_TAG_BONUS_BUY_BG_TEXT;
		default:
			console.error(`Missing case for event type ${eventType}`); // eslint-disable-line no-console
	}
};

export default function EventTypeTitle({ eventType, translations, transparentBg }) {
	return (
		<div className={`event-type-title-bg ${transparentBg ? 'event-type-transparent' : ''}`}>
			<h1 className={`event-type-title-text ${eventType}`}>{getTranslation(eventType, translations)}</h1>
		</div>
	);
}
